import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Button = ({ text, onClick, to, className = "", icon, variant = "primary" }) => {
  const baseClasses = "relative inline-flex items-center justify-center gap-2 font-semibold rounded-full transition-all duration-300 overflow-hidden group";
  const sizeClasses = "px-8 py-3 text-base md:px-10 md:py-3.5";

  // Variant styles
  const variantClasses = {
    primary: "bg-gradient-primary text-white shadow-md hover:shadow-primary hover:-translate-y-1",
    secondary: "bg-white text-primary border-2 border-primary hover:bg-primary hover:text-white shadow-md hover:shadow-primary",
    outline: "bg-transparent text-primary border-2 border-primary hover:bg-primary hover:text-white",
  };

  const combinedClasses = `${baseClasses} ${sizeClasses} ${variantClasses[variant]} ${className}`;

  // Ripple effect component
  const RippleEffect = () => (
    <span className="absolute inset-0 overflow-hidden rounded-full">
      <span className="absolute inset-0 bg-white/20 transform scale-0 group-hover:scale-100 transition-transform duration-500 rounded-full"></span>
    </span>
  );

  // Shine effect
  const ShineEffect = () => (
    <span className="absolute inset-0 overflow-hidden rounded-full">
      <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/20 to-transparent"></span>
    </span>
  );

  const ButtonContent = () => (
    <>
      <RippleEffect />
      <ShineEffect />
      <span className="relative z-10 flex items-center gap-2">
        {icon && <span className="transition-transform group-hover:scale-110">{icon}</span>}
        {text}
      </span>
    </>
  );

  // Button Link
  if (to) {
    return (
      <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
        <Link to={to} className={combinedClasses}>
          <ButtonContent />
        </Link>
      </motion.div>
    );
  }

  // Regular Button
  return (
    <motion.button
      onClick={onClick}
      className={combinedClasses}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      <ButtonContent />
    </motion.button>
  );
};

export default Button;
